<script setup lang="ts">
import type { PropType } from 'vue'
import type { ChartDataset } from 'chart.js'

const props = defineProps({
  datasets: {
    type: Object as PropType<ChartDataset[]>,
    required: true,
  },
  isPieLegend: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['click-legend-item'])

const onToggle = (datasetIndex, isVisible) => {
  if (!props.isPieLegend) {
    emit('click-legend-item', datasetIndex, isVisible)
  }
}

/*
  Legend color can also be a patterns or gradients,
  which are objects. We currently don't support other
  but string color.

  See:
  - https://www.chartjs.org/docs/latest/general/colors.html
*/
const getBackgroundColor = (color) => {
  return typeof color === 'string' ? color : ''
}
</script>

<template>
  <section class="grid grid-cols-2 gap-x-20 gap-y-2.5 md:grid-cols-3">
    <ChartLegendItem
      v-for="(dataset, id) in datasets"
      :key="id"
      :text="dataset.label"
      :color="getBackgroundColor(dataset.backgroundColor)"
      :is-interactive="!isPieLegend"
      @click="(isVisible) => onToggle(id, isVisible)"
    />
  </section>
</template>
